import { ReactElement, useMemo, useEffect, Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import FormRegion from 'system/geographic/components/region/form';
import { CommonConsulateCrumbs } from '../constants';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import { useNavigate, useParams } from 'react-router-dom';
import { Region } from 'shell/models/region';
import { HttpResponse } from 'shell/models/http-response';
import { RegionForm } from 'system/geographic/pages/region/list/types';
import { toast } from 'react-toastify';

const RegionEditPage = (): ReactElement => {
  const params = useParams();

  const { put: updateRegion } = useHttpFetch(
    `${__MUNICIPALITY_API_URL__}/geo/regione/${params.id}`
  );

  const {
    get: getRegion,
    data,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Region>>(`${__MUNICIPALITY_API_URL__}/geo/regione/${params.id}`);

  useEffect(() => {
    getRegion();
  }, []);

  const initialValues: RegionForm = useMemo(() => {
    const consulatePayload = data?.payload;
    if (!consulatePayload || !!error) {
      // empty
      return {
        code: '',
        name: '',
      };
    }
    return {
      code: consulatePayload.key?.codice,
      name: consulatePayload.nome,
    };
  }, [data, error]);

  const navigate = useNavigate();

  const onSave = useCallback(
    (formValues: RegionForm | undefined) => {
      updateRegion({
        nome: formValues?.name,
        key: {
          codice: formValues?.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/italia/regione');
      });
    },
    [updateRegion, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonConsulateCrumbs, { name: 'Modifica regione' }]} />
      {!loading && !error ? (
        <FormRegion title="Modifica regione" onSave={onSave} isEdit initialValues={initialValues} />
      ) : null}
    </Fragment>
  );
};

RegionEditPage.displayName = 'Page edit region';

export default RegionEditPage;
